import { jsx as _jsx } from "react/jsx-runtime";
export const SourgumFifteenYdDimensions2 = (props) => {
    const src = new URL('./dumpster-15.png', import.meta.url).toString();
    return _jsx("img", { ...props, src: src, alt: "Fifteen Yard Dimensions" });
};
//# sourceMappingURL=fifteen-yard-dimensions-sourgum2.js.map